import { observer } from "mobx-react";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import React from "react";
import styled from "styled-components";
import { useStore2 } from "../../../../WSUtils/useStore";
import { concatClassnames } from "../../../../WSUtils/util";
import { CVEChoiceStore } from "./CVEChoiceOptionStore";
import { CVEQuestionProps } from "./CVEQuestion";

export const CVEChoiceOption = observer(
  ({ question, option, hidden }: CVEQuestionProps) => {
    const storeName = `CVEQuestionStore_choice_${question.id}_${option.id}`;

    const store = useStore2(
      storeName,
      (dt) =>
        new CVEChoiceStore({
          name: storeName,
          parentDt: dt,
        })
    );

    store._onRender(question, option);

    const inputId = `Category_${option.id}`;

    return (
      <StyledCVEChoiceAnswer className="cve-choice-answer" key={inputId}>
        <div className="p-field-checkbox cvp-checkbox" key={option.id}>
          {question.allowMultiple && (
            <Checkbox
              disabled={hidden}
              inputId={inputId}
              checked={!!store.isChecked}
              onChange={(evt) => {
                store.onChange(evt.checked);
              }}
            />
          )}
          {!question.allowMultiple && (
            <RadioButton
              disabled={hidden}
              inputId={inputId}
              checked={!!store.isChecked}
              onChange={(evt) => {
                store.onChange(evt.checked);
              }}
            />
          )}
          <label
            htmlFor={inputId}
            className={concatClassnames([
              "p-checkbox-label",
              "cve-choice-answer-label",
              hidden && "cve-choice-answer-label-hidden",
            ])}
          >
            {option.optionName}
          </label>
        </div>
      </StyledCVEChoiceAnswer>
    );
  }
);

export const StyledCVEChoiceAnswer = styled.div`
  &.cve-choice-answer {
    margin-top: 0.25rem;

    .cve-choice-answer-label {
      margin-left: 0.1rem;
    }

    .cve-choice-answer-hidden {
      color: var(--gray-700);
      opacity: 0.65;
    }
  }
`;
